/* eslint-disable no-bitwise */
export const Permissions = {
  ADMIN: 1 << 0,
  PX: 1 << 1,
  QA: 1 << 2,
  SUPER_ADMIN: 1 << 30 // Max safe value, this should always be the last one...
};

export function hasPermission(userPermission, permission) {
  return !!(userPermission & permission);
}

export function addPermission(userPermission, permission) {
  return userPermission | permission;
}

export function removePermission(userPermission, permission) {
  return userPermission & ~permission;
}



// WEBPACK FOOTER //
// ../thriller-core/Permissions.js